import { useTranslation } from 'react-i18next'
import { useField } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { NotificationInline } from '../../../Notification'
import { ButtonSelect } from '../../../Select'
import { isEpostFormFieldsRegisteredLetterInternationalOption } from '../EpostFormFields.utils'

function EpostFormFieldsRegisteredLetterSelect({ name, ...restProps }) {
  const { t } = useTranslation()

  const [field] = useField(name)

  return (
    <>
      <ButtonSelect
        {...restProps}
        controlProps={{
          borderless: true,
          indicatorsProps: {
            ButtonClear: null,
          },
        }}
        name={name}
      />
      {isEpostFormFieldsRegisteredLetterInternationalOption(field.value) ? (
        <NotificationInline
          text={t(
            'Epost.RegisteredLetterInternationalWarningNotificationTextKey'
          )}
          type={NOTIFICATION_TYPE.warning}
        />
      ) : null}
    </>
  )
}

export default EpostFormFieldsRegisteredLetterSelect
